
import i18next from "i18next"

import LogoBicycode from "components/Elements/logos/LogoBicycode"
import LogoMFC from "components/Elements/logos/LogoMFC"
import { LogoMoustache } from "components/Elements/logos/LogoMoustache"
import LogoOcode from "components/Elements/logos/LogoOcode"
import { BC_CGU_LINK, BC_LEGAL_NOTICE, MC_CGU_LINK, MC_LEGAL_NOTICE, MFC_CGU_LINK, MFC_LEGAL_NOTICE } from "./misc"
import { Operator } from "models"

export const MFC_OPERATOR = "MF"
export const MFC_OPERATOR_NAME = "MFC"

export const BC_OPERATOR = "BC"
export const BC_OPERATOR_NAME = "Bicycode"

export const DK_OPERATOR = "DK"

export const MC_OPERATOR = "MC"
export const MC_OPERATOR_NAME = "Moustache"

export const MFC_RETAIL_GENDER = "RETAIL"
export const MFC_SUNN_GENDER = "SUNN"
export const MFC_INTER_GENDER = "INTER"

export const ACTIVE_OPERATOR_STATUS = 1
export const INACTIVE_OPERATOR_STATUS = 2

export const operatorList = [
    { id: BC_OPERATOR, label: i18next.t("operators.bicycode"), logo: "bicycode" },
    { id: MFC_OPERATOR, label: i18next.t("operators.mfc"), logo: "mfc" },
    { id: DK_OPERATOR, label: i18next.t("operators.decathlon"), logo: "decathlon" },
    { id: MC_OPERATOR, label: i18next.t("operators.moustache"), logo: "moustache" }
]

export const genderMFCList = [
    { id: "retailer", value: 0, label: "partner:storeGender.retailer", id_api: MFC_RETAIL_GENDER },
    { id: "sunn", value: 1, label: "partner:storeGender.sunn_retailer", id_api: MFC_SUNN_GENDER },
    { id: "intersport", value: 2, label: "partner:storeGender.intersport", id_api: MFC_INTER_GENDER },
]

export const defaultEntity: Operator = {
    name: "O°Code",
    id: "ocode",
    id_api: "OC",
    logo: LogoOcode,
    theme: {
        primaryColor: "#262626",
        primaryColor90: "#333333",
        secondaryColor: "#C53762",
        textColor: "black",
        bodyBackground: "white",
        bodyColor: "black",
        linkColor: "black",
    },
    allowed_gender: [0, 1, 2, 3]
}

export const operators: Operator[] = [
    {
        name: BC_OPERATOR_NAME,
        id: "bicycode",
        id_api: BC_OPERATOR,
        logo: LogoBicycode,
        theme: {
            primaryColor: "#1B1464",
            primaryColor90: "#292281",
            secondaryColor: "#C53762",
            textColor: "#1B1464",
            bodyBackground: "#F2F3F4",
            bodyColor: "#1B1464",
            linkColor: "#1B1464",
        },
        enrolmentProcess: ["gender", "email", "structure", "manager", "bicycode-services", "store", "password", "success"],
        allowed_gender: [1, 2, 3],
        cguDocumentName: BC_CGU_LINK,
        legalNoticeDocumentName: BC_LEGAL_NOTICE,
        phone: "02 79 93 60 10",
        internationalphone: "+33 2 79 93 60 10"
    },
    {
        name: MFC_OPERATOR_NAME,
        id: "mfc",
        id_api: MFC_OPERATOR,
        logo: LogoMFC,
        theme: {
            primaryColor: "#111111",
            primaryColor90: "#222222",
            secondaryColor: "#C53762",
            textColor: "black",
            bodyBackground: "white",
            bodyColor: "black",
            linkColor: "black",
        },
        allowed_gender: [0],
        cguDocumentName: MFC_CGU_LINK,
        legalNoticeDocumentName: MFC_LEGAL_NOTICE,
        phone: "02 52 68 15 56",
        internationalphone: "+33 2 52 68 15 56"
    },
    {
        name: MC_OPERATOR_NAME,
        id: "mc",
        id_api: MC_OPERATOR,
        logo: LogoMoustache,
        theme: {
            primaryColor: "#0A0A0A",
            primaryColor90: "#242323",
            secondaryColor: "#C53762",
            textColor: "black",
            bodyBackground: "white",
            bodyColor: "black",
            linkColor: "black",
        },
        allowed_gender: [0],
        cguDocumentName: MC_CGU_LINK,
        legalNoticeDocumentName: MC_LEGAL_NOTICE,
        phone: "03 72 60 20 00",
        internationalphone: "+33 3 72 60 20 00"
    },
    // {
    //     name: "Decathlon",
    //     id: "decathlon",
    //     id_api: DK_OPERATOR,
    //     logo: LogoDecathlon,
    //     theme: {
    //         primaryColor: "#0082c3",
    //         secondaryColor: "#C53762",
    //         textColor: "#0082c3",
    //         bodyBackground: "white",
    //         bodyColor: "#0082c3",
    //         linkColor: "#0082c3",
    //     }
    // }
]

export const anyOperators = operators.map(op => op.id_api)
